var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { SupportingText } from './SupportingText';
import { Text } from './Text';
/**
 * [Storybook](https://guardian.github.io/source/?path=/docs/source-src-label-label-) •
 * [Design System](https://theguardian.design/2a1e5182b/p/40151e-label/b/86af7d) •
 * [GitHub](https://github.com/guardian/source/tree/main/packages/@guardian/src-label) •
 * [NPM](https://www.npmjs.com/package/@guardian/src-label)
 *
 * A label describes a user input field.
 *
 * Label is used by other Source components, such as TextInput. Only use Label
 * if you are building your own form components.
 *
 * The following themes are supported: `light`, `brand`.
 * */
export const Label = (_a) => {
    var { text, supporting, optional = false, hideLabel = false, cssOverrides, children } = _a, props = __rest(_a, ["text", "supporting", "optional", "hideLabel", "cssOverrides", "children"]);
    return (_jsxs("label", Object.assign({ css: cssOverrides }, props, { children: [_jsx(Text, { hideLabel: hideLabel, text: text, optional: optional }, void 0), supporting ? (_jsx(SupportingText, Object.assign({ hideLabel: hideLabel }, { children: supporting }), void 0)) : (''), children] }), void 0));
};
//# sourceMappingURL=Label.js.map
